// extracted by mini-css-extract-plugin
export default {"title-container":"TermosDeUso_title-container__-ZNQL","use-terms-container":"TermosDeUso_use-terms-container__Y6x1V"};